import { render, staticRenderFns } from "./ThreeSteps.vue?vue&type=template&id=29b47c94&scoped=true&"
import script from "./ThreeSteps.vue?vue&type=script&lang=ts&"
export * from "./ThreeSteps.vue?vue&type=script&lang=ts&"
import style0 from "./ThreeSteps.vue?vue&type=style&index=0&id=29b47c94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b47c94",
  null
  
)

export default component.exports